(function () {

  const selectToggle = document.querySelectorAll('.select-toggle');

  selectToggle.forEach(element => {

    const toggleContent = element.querySelector('.toggle-content');

    const clearToggleContent = () => toggleContent.innerHTML = '';

    const content = {};
    element.querySelectorAll('.toggle-content .toggle-content-single[data-toggle]').forEach(item => {
      content[item.dataset.toggle] = item;
      item.remove();
    });

    const select = element.querySelector('select');
    select.addEventListener('change', e => {
      const { toggle } = e.target.selectedOptions[0].dataset;
      if (toggle) {
        clearToggleContent();
        if (content[toggle]) {
          toggleContent.appendChild(content[toggle].cloneNode(true));
        }
      } else {
        clearToggleContent();
      }
    });

  });

})();
